/* global Stripe */

const form = document.getElementById('payment-form');
const partnerInput = document.querySelector('input.partner');
const promoInput = document.querySelector('input.promo');
const emailFormElement = document.getElementById('emailinput');
const firstNameFormElement = document.getElementById('firstnameinput');
const lastNameFormElement = document.getElementById('lastnameinput');
const errorElement = document.getElementById('card-errors');
let payButton = document.querySelector('button.pay-btn');
let stripeFormSetup = false;
let elements = undefined;
let signupIsEmailCurrentMember = false;
var htmlBody = document.getElementById('mainbody');

//-------------------

const initSignupLinks = function () {
    document.querySelectorAll('.join').forEach((joinLink) => {
        joinLink.addEventListener("click", () => {
            htmlBody.style.overflow = 'hidden';
            if (signupIsEmailCurrentMember === true) {
                MicroModal.close('cardModal');
                MicroModal.show('currentMemberModal', {
                    onClose: allowBodyOverflow
                });
            } else {
                MicroModal.show('cardModal', {
                    onClose: allowBodyOverflow
                });
            }
        });
    });
}

let allowBodyOverflow = function () {
    htmlBody.style.overflow = '';
}

const handleError = (error) => {
    console.log(error);
    if (error !== undefined) {
        console.log(error.message);
        errorElement.textContent = error.message;
    }
    payButton.textContent = 'Make Payment';
    payButton.disabled = false;
    payButton.setAttribute('disabled', 'disabled');
    payButton.removeAttribute('disabled');
    payButton.classList.remove('disabled');
}

/**
 * Set up the signup form with the Stripe tokeniser
 */
const initStripeForm = function () {

    if (stripeFormSetup === false) {

        const appearance = { /* appearance */};

        let successLinkInput = document.createElement('input');
        successLinkInput.setAttribute('type', 'hidden');
        successLinkInput.setAttribute('name', 'successLink');
        successLinkInput.setAttribute('value', form.dataset.slink);
        form.appendChild(successLinkInput);

        elements = stripe.elements({
            mode: 'setup',
            currency: 'gbp',
            off_session: 'off_session',
            payment_method_configuration: stripePaymentMethodConfiguration
        }, appearance);

        const options = {
            layout: {
                type: 'tabs',
                defaultCollapsed: false,
            },
        };

        const paymentElement = elements.create('payment', options);
        paymentElement.mount('#card-element');

        form.addEventListener('submit', async function (event) {

            event.preventDefault();

            console.log('form submission in progress');

            if (payButton.disabled) {
                return;
            }

            payButton.textContent = 'Please wait a moment...';
            payButton.setAttribute('disabled', 'disabled');
            payButton.classList.add('disabled');

            //Send the data to the backend
            const formData = new FormData(form);

            let signUpFormComplete = checkSignupFormDetailsComplete();

            if (signUpFormComplete === true) {

                console.log('Signup form complete');

                const createIntentRequest = new XMLHttpRequest();

                createIntentRequest.addEventListener("load", async function (res) {

                    console.log('Intent firing');

                    elements.submit().then(async function (result) {

                        if (result.hasOwnProperty('error') === false) {

                            console.log('Payment form okay');

                            const resData = JSON.parse(res.target.responseText);

                            console.log(resData);

                            let status = resData.status;

                            if (status === -1) {
                                handleError(resData);
                            } else {

                                let clientSecret = resData.clientSecret;
                                let returnURL = resData.returnURL;

                                // Confirm the Intent using the details collected by the Payment Element
                                const {error} = await stripe.confirmSetup({
                                    elements,
                                    clientSecret,
                                    confirmParams: {
                                        return_url: returnURL,
                                    },
                                });

                                if (error) {
                                    handleError(error);
                                } else {
                                    // Your customer is redirected to your `return_url`.
                                }
                            }
                        } else {
                            handleError(result.error);
                            console.log('Submit invalid');
                        }

                    });

                });

                createIntentRequest.addEventListener("error", function (event) {
                    errorElement.innerText = "Sorry, there was a problem sending your data.  Please refresh the page and try again";
                });

                createIntentRequest.open("POST", '/charge/intent');
                createIntentRequest.send(formData);

            }

        });

        stripeFormSetup = true;
        console.log('Setup stripe form');
    } else {
        console.log('Stripe form already setup');
    }
}

const checkSignupFormDetailsComplete = function () {
    let emailFormElementValue = emailFormElement.value;
    let firstNameFormElementValue = firstNameFormElement.value;
    let lastNameFormElementValue = lastNameFormElement.value;

    let errorMessage = '';

    if (emailFormElementValue === null || emailFormElementValue === '') {
        errorMessage += 'Email is required';
    }

    if (firstNameFormElementValue === null || firstNameFormElementValue === '') {
        if (errorMessage !== '') {
            errorMessage += ', ';
        }
        errorMessage += 'First name is required';
    }

    if (lastNameFormElementValue === null || lastNameFormElementValue === '') {
        if (errorMessage !== '') {
            errorMessage += ', ';
        }
        errorMessage += 'Last name is required';
    }

    if (errorMessage !== '') {
        handleError({message: errorMessage});
        return false;
    } else {
        return true;
    }
}

const getUrlVars = function () {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

const removeParam = function (key, sourceURL) {
    let rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

//---------------------------------

function populateGaClientId() {
    const measurementId = 'G-PH1KY1RHWQ';
    const fields = document.querySelectorAll('[name="gaclientid"]');
    const maxAttempts = 20;
    const interval = 250;

    let attempts = 0;

    function attempt() {
        if (!fields.length) {
            console.log('No fields to fill');
            return retry();
        }
        if (!fields.length || typeof window.gtag !== 'function') {
            console.log('gtag not found');
            return retry();
        }

        window.gtag('get', measurementId, 'client_id', function (clientId) {
            if (clientId) {
                console.log('filling client ID: ' + clientId);
                fields.forEach(function (field) {
                    field.value = clientId;
                });

                return;
            }

            console.log('no client Id found');
            retry();
        });
    }

    function retry() {
        attempts++;

        if (attempts < maxAttempts) {
            setTimeout(attempt, interval);
        }
    }

    attempt();
}

document.addEventListener("DOMContentLoaded", () => {
    MicroModal.init();
    populateGaClientId();
    initSignupLinks();
    initStripeForm();
});


let promo = getUrlVars()['promo'];
let acceptCookies = getUrlVars()['acceptCookies'];

//If there is a promo code in the URL, populate the partner and promo fields
if (promo !== undefined) {
    if (partnerInput !== null) {
        partnerInput.value = promo;
    }
    if (promoInput !== null) {
        promoInput.value = promo;
    }
}

const siteURL = window.location.href;
let pageURL = siteURL.split("/").pop();

//If we're not on the main site page, use the path as the partner code
if (pageURL !== undefined) {

    // Check if the cookie parameter exist in URL and remove it from promo text-field
    if (acceptCookies !== undefined) {
        const remParam = removeParam('acceptCookies', siteURL);
        pageURL = remParam.split("/").pop();

        if (pageURL !== undefined) {
            partnerInput.value = pageURL;
        }
    }

    // Set page URL as the new promo code
    if (partnerInput !== null) {
        partnerInput.value = pageURL;
    }

    // Set promo text field if promo parameter in URL is not undefined
    if ((promo !== undefined) && (promoInput !== null)) {
        promoInput.value = promo;
    }
}
